import React, { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { ImpressionRegion, ImpressionW3ddlData } from '@sparknz/tracking';

import { GalleryProduct } from 'shared/components/ProductGalleryCard/typings';
import { buildTrackingProductData } from 'shared/components/ProductGalleryCard/utils/buildTrackingProductData.utils';
import { Channel, Segment, useSegment } from 'shared/hooks';

interface BuildImpressionDataParams
  extends DeviceGalleryCardImpressionRegionProps {
  numFilters: number;
  segment: Segment;
  channel: Channel;
}

function buildImpressionData({
  numFilters,
  numProducts,
  product,
  promoDealString,
  promoTag,
  selectedBrandValues,
  selectedColorValues,
  selectedPrice,
  selectedSubcategoryId,
  sortOrder,
  segment,
  channel,
}: BuildImpressionDataParams): ImpressionW3ddlData {
  return {
    component: [
      {
        componentInfo: {
          componentID: `shop.productCards.${selectedSubcategoryId}`,
          componentName: `Shop ${selectedSubcategoryId}`,
        },
        category: {
          primaryCategory: 'Product',
          subCategory1: selectedSubcategoryId,
        },
        attributes: {
          filterInfo: {
            primaryCategory: selectedSubcategoryId,
            category: selectedSubcategoryId,
            numOfCategory: '1',
            colors: selectedColorValues,
            numOfcolors: selectedColorValues?.length.toString(),
            brands: selectedBrandValues,
            numOfBrands: selectedBrandValues?.length.toString(),
            priceMin: '0',
            priceMax: selectedPrice.toString(),
            sortBy: sortOrder,
            numOfResults: numProducts.toString(),
            numOFFilters: numFilters.toString(), // To do: fix this name in tracking lib
          },
        },
      },
    ],
    event: [
      {
        attributes: {
          isSuccess: true,
        },
      },
    ],
    product: buildTrackingProductData({
      product,
      segment,
      channel,
      promoDealString,
      promoTag,
    }),
  };
}

interface DeviceGalleryCardImpressionRegionProps {
  numProducts: number;
  product: GalleryProduct;
  promoDealString: string;
  promoTag: string;
  selectedBrandValues: string[];
  selectedColorValues: string[];
  selectedPrice: string[];
  selectedSubcategoryId: string;
  sortOrder: string;
}

export default function DeviceGalleryCardImpressionRegion({
  children,
  ...props
}: PropsWithChildren<DeviceGalleryCardImpressionRegionProps>) {
  const router = useRouter();
  const numFilters = Object.keys(router.query).length;

  const { segment, channel } = useSegment();

  const impressionData: ImpressionW3ddlData = buildImpressionData({
    segment,
    channel,
    numFilters,
    ...props,
  });

  return (
    <ImpressionRegion
      threshold={0.7}
      batchEvent
      impressionData={impressionData}
    >
      {children}
    </ImpressionRegion>
  );
}
